function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import Account from 'modules/Account';
import * as constants from '../../../../constants';
import messages from '../../../../messages';
import styles from '../../DownloadDataModal.pcss';
import AppStoreLinks from './AppStoreLinks';
const b = (chunk)=>/*#__PURE__*/ _jsx("b", {
        children: chunk
    });
const getInfoMessage = (warningType, warningsLen, activeProfileType)=>{
    const singleTxt = warningsLen === 1 ? 'Single' : '';
    switch(warningType){
        case constants.WARNING_TYPES.MISMATCH_TARGET_RANGES:
            {
                if (activeProfileType === Account.constants.PROFILE_TYPES.PWD) {
                    return messages.infos[`warningMismatchTargetRanges${singleTxt}`];
                }
                return messages.infos[`warningMismatchTargetRanges${singleTxt}Hcp`];
            }
        default:
            {
                return messages.infos[`warning${warningType}${singleTxt}`];
            }
    }
};
const WarningHeader = ({ warningType, warningsLen })=>{
    if (warningsLen === 1) {
        return null;
    }
    return /*#__PURE__*/ _jsx("h3", {
        className: "brand__paragraph--bold",
        children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.headers[`warning${warningType}`]))
    });
};
const WarningInfo = ({ warningType, warningsLen })=>{
    const activeProfileType = useSelector(Account.selectors.activeProfileType);
    const countryId = useSelector(Account.selectors.countryId);
    const message = getInfoMessage(warningType, warningsLen, activeProfileType);
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsx("p", {
                className: "brand__paragraph brand__fontSecondary",
                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread_props(_object_spread({}, message), {
                    values: {
                        b
                    }
                }))
            }),
            warningType === constants.WARNING_TYPES.MISMATCH_TARGET_RANGES && activeProfileType === Account.constants.PROFILE_TYPES.PWD && /*#__PURE__*/ _jsx(AppStoreLinks, {
                countryId: countryId
            })
        ]
    });
};
const WarningBox = ({ warningType, warningsLen, idx })=>/*#__PURE__*/ _jsx("div", {
        className: "row align-items-center",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "col",
            children: [
                /*#__PURE__*/ _jsx(WarningHeader, {
                    warningType: warningType,
                    warningsLen: warningsLen
                }),
                /*#__PURE__*/ _jsx(WarningInfo, {
                    warningType: warningType,
                    warningsLen: warningsLen
                }),
                warningsLen > 1 && idx !== warningsLen - 1 && /*#__PURE__*/ _jsx("div", {
                    className: styles.warnings__hr
                })
            ]
        })
    });
export default WarningBox;
